
$(function () {
    $('.product-slider').owlCarousel({
        loop:false,
        margin:0,
        nav:true,
        responsive:{
            0: {
                items: 1
            },
            768:{
                items:3
            },
            1000:{
                items:4
            }
        }
    });

    $('.others-slider').owlCarousel({
        loop:false,
        margin:0,
        nav:true,
        responsive:{
            0: {
                items: 1
            },
            768:{
                items:3
            },
            1000:{
                items:4
            }
        }
    });

    $('.brand-slider').owlCarousel({
        loop:false,
        margin:0,
        nav:true,
        responsive:{
            0: {
                items: 1
            },
            660:{
                items:1
            },
            1000:{
                items:5
            }
        }
    });

    $('.catalog-category-slider').owlCarousel({
        loop:false,
        margin:0,
        nav:true,
        responsive:{
            0: {
                items: 1
            },
            768:{
                items:3
            },
            1000:{
                items:4
            }
        }
    });

    $('.compare-slider').owlCarousel({
        loop:false,
        margin:0,
        nav:true,
        responsive:{
            0: {
                items: 1
            },
            768:{
                items:2
            },
            1000:{
                items:3
            }
        }
    });

    //Megamenu
    $('#megamenu').on('shown.bs.collapse', function() {
        if($('#megamenu').hasClass('show')) {
            $('#menu-overlay').show();
        }
    });
    $('#megamenu').on('hidden.bs.collapse', function() {
        if(!$('#megamenu').hasClass('show')) {
            $('#menu-overlay').hide();
        }
    });
    $('#megamenu-top > li > a').on('click', function () {
      $('.megamenu-category').collapse('hide');
    });
    $('.megamenu-category > li > a').on('click', function () {
        $('.megamenu-items').collapse('hide');
    });

    // $('.action-favorite, .action-compare, .cart-action__favorite').on('click', function() {
    //    $(this).toggleClass('active');
    // });
    // $('.catalog-category-item__action--favorite').on('click', function() {
    //     $(this).toggleClass('active');
    //     $(this).hasClass('active') ? $(this).find('.catalog-category-item__action-text').text('в избранном') : $(this).find('.catalog-category-item__action-text').text('в избранное');
    // });
    // $('.catalog-category-item__action--compare').on('click', function() {
    //     $(this).toggleClass('active');
    //     $(this).hasClass('active') ? $(this).find('.catalog-category-item__action-text').text('в сравнении') : $(this).find('.catalog-category-item__action-text').text('к сравнению');
    // });

    $('.tax-select span').on('click', function() {
        if(!$(this).hasClass('active')) {
            $(this).toggleClass('active');
            $(this).siblings().toggleClass('active');
        }
    });

    $('.catalog-show-more').on('click', function() {
        $(this).prev().toggleClass('opened');

        var isOpened = $(this).prev().hasClass('opened');

        if(isOpened) {
            $(this).text('Скрыть позиции');
            $(this).closest('.catalog-category').height('auto');
        } else {
            $(this).text('+ ' + $(this).data('count') + ' позиций');
            $(this).closest('.catalog-category').height(380);
        }
    });

    $('.catalog-category-title').on('click', function() {
        $(this).closest('.catalog-category').toggleClass('opened')
    });

    $(".catalog-category-item__rating").rateYo({
        rating: 4,
        starWidth: "15px",
        ratedFill: "#333",
        normalFill: "#d4d4d4",
        fullStar: true
    });

    $('.badge').on('click', function() {
        $(this).toggleClass('badge-default').toggleClass('badge-selected')
    });

    $("#display-range").slider({
        range: true,
        orientation: "horizontal",
        min: 3.5,
        max: 25,
        values: [0, 35],
        step: 0.1,
        slide: function (event, ui) {
            if (ui.values[0] == ui.values[1]) {
                return false;
            }
            $("#min_width").val(ui.values[0]);
            $("#max_width").val(ui.values[1]);
        }
    });
    $("#price-range").slider({
        range: true,
        orientation: "horizontal",
        min: 0,
        max: 100000,
        values: [0, 100000],
        step: 100,
        slide: function (event, ui) {
            if (ui.values[0] == ui.values[1]) {
                return false;
            }
            $("#min_price").val(ui.values[0]);
            $("#max_price").val(ui.values[1]);
        }
    });

    //Deatail page
    $('.detail-carousel-pagination li').on('click', function() {
       $(this).siblings().removeClass('active');
       $(this).toggleClass('active');
    });

    $('.color-variants__item').on('click', function() {
        $(this).siblings().removeClass('active');
        $(this).toggleClass('active');
    });

    $('.catalog-item-detail__variants .badge').on('click', function() {
        $(this).siblings().removeClass('badge-selected').addClass('badge-default');
        $(this).removeClass('badge-default').addClass('badge-selected');
    });

    //Checkout
    $('.delivery-block').on('click', function(e) {
        e.stopPropagation();
        $('.delivery-block').removeClass('active');
        $(this).find('[type=radio]').prop('checked', true);
        $(this).addClass('active');
    });

    //Enable popover
    $(".compare-sidebar-row [data-toggle=popover]").popover();
    $(".table [data-toggle=popover]").popover({
        html : true,
        placement: 'left',
        content: function() {
            var content = $(this).attr("data-popover-content");
            return $(content).children(".popover-body").html();
        },
    });
    $('body').on('click', '.popover-body .close', function() {
        $("[data-toggle=popover]").popover('hide')
    });

    //LK
    var lkMenuOpened = false;
    $('.lk-menu a.active').on('click', function(e) {
        if ($(window).width() <= 535) {
            e.preventDefault();
            if (!lkMenuOpened) {
                $(this).parent().siblings().find('a').css('display', 'flex');
                $(this).parent().css({
                    'order': '-1',
                    'border-bottom': '1px solid #dcdcdc'
                });
                lkMenuOpened = true;
            } else {
                $(this).parent().siblings().find('a').css('display', 'none');
                $(this).parent().css({
                    'order': '0',
                    'border-bottom': '0 none'
                });
                lkMenuOpened = false;
            }
        }
    });

    $('.toggle-filter-mob').on('click', function() {
        $('.catalog-sidebar').addClass('mobile-view');
    });

    $('.filter-close').on('click', function() {
        $('.catalog-sidebar').removeClass('mobile-view');
    });

    var sortMenuOpened = false;
    $('.type-select label').on('click', function(e) {
        if ($(window).width() <= 535) {
            e.preventDefault();
            var radio = $('#'+$(this).attr('for')).prop("checked", true);
            if (!sortMenuOpened) {
                $(this).parent().find('label').css('display', 'flex');

                sortMenuOpened = true;
            } else {
                $(this).parent().find('label').css({
                    'display': 'none',
                    'order': '0',
                    'border': '0 none'
                });
                $(this).css({
                    'display': 'flex',
                    'order': '-1',
                    'border': '1px solid #dcdcdc'
                });
                sortMenuOpened = false;
            }
        }
    });

    $('.file-attach').on('click', function(e) {
        e.preventDefault();
        $(this).next(['type=file']).click();
    });

    $(".license-item__image a").fancybox({
        baseClass: 'license-modal'
    });

});


// WEBPACK FOOTER //
// ./resources/assets/js/origin.js